// extracted by mini-css-extract-plugin
export var box = "_6q-1";
export var checked = "_6q-2";
export var descriptionSpacer = "_6q-9";
export var disabled = "_6q-3";
export var icon = "_6q-6";
export var input = "_6q-0";
export var labelSpacer = "_6q-8";
export var medium = "_6q-5";
export var small = "_6q-4";
export var text = "_6q-7";